//
// TRIL-116: multi-surface nudge per spec §366. Surface determines treatment
// (profile = top banner with brand accent, feed_sidebar = compact widget).

import { X } from 'lucide-react';
import * as React from 'react';
import { trackEvent } from '../../../helpers/analytics';
import type { ProfessionalContext } from '../../../interfaces/user.interface';
import { CompletionPercentageWidget } from '../CompletionPercentageWidget';
import './profile-completion-nudge.scss';

export type NudgeSurface = 'profile' | 'feed_sidebar';

interface Props {
  surface: NudgeSurface;
  shouldShow: boolean;
  completionPct: number;
  dismissCount: number;
  context: ProfessionalContext | null;
  onDismiss: () => Promise<void> | void;
  onCtaClick: () => void;
}

export function ProfileCompletionNudge({
  surface,
  shouldShow,
  completionPct,
  dismissCount,
  context,
  onDismiss,
  onCtaClick,
}: Props): React.ReactElement | null {
  React.useEffect(() => {
    if (shouldShow) {
      trackEvent('plan_c.nudge.shown', {
        surface,
        completion_pct: completionPct,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldShow, surface]);

  if (!shouldShow) return null;

  const handleDismiss = (): void => {
    trackEvent('plan_c.nudge.dismissed', {
      surface,
      dismiss_count: dismissCount + 1,
    });
    void onDismiss();
  };

  const handleCta = (): void => {
    trackEvent('plan_c.nudge.cta_clicked', { surface });
    onCtaClick();
  };

  return (
    <div className={`plan-c-nudge plan-c-nudge--${surface}`}>
      <button
        type="button"
        aria-label="Dismiss"
        onClick={handleDismiss}
        className="plan-c-nudge__close"
      >
        <X size={16} />
      </button>
      <h3 className="plan-c-nudge__heading">Boost your post credibility</h3>
      <p className="plan-c-nudge__body">
        URG (User Reputation Generator) can rate your expertise more accurately
        when it knows your background. About 30 seconds.
      </p>
      <CompletionPercentageWidget context={context} />
      <div className="plan-c-nudge__actions">
        <button
          type="button"
          onClick={handleCta}
          className="plan-c-nudge__button-primary"
        >
          Complete profile
        </button>
        <button
          type="button"
          onClick={handleDismiss}
          className="plan-c-nudge__button-secondary"
        >
          Maybe later
        </button>
      </div>
    </div>
  );
}
